import { EmbeddedSignupSchema, EmbeddedSignupSessionEventSchema } from "schema"
import { z } from "zod"

type Session = {
  companyId?: string
  code?: string
  event?: z.infer<typeof EmbeddedSignupSessionEventSchema>
  isSubmitted: boolean
}

export const createEmbeddedSignupSession = (companyId?: string) => {
  const session: Session = { companyId, isSubmitted: false }
  return session
}

export const takeEmbeddedSignupPayload = (session: Session) => {
  const { code, event, companyId } = session
  if (session.isSubmitted || !code || !event?.data?.waba_id) return

  const isCoexistence = event.event === "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING"
  if (event.event !== "FINISH" && !isCoexistence) return
  if (!isCoexistence && !event.data.phone_number_id) return
  if (isCoexistence && !companyId) return

  session.isSubmitted = true

  return {
    code,
    companyId,
    businessId: event.data.waba_id,
    phoneId: event.data.phone_number_id,
    isCoexistence,
  } satisfies z.input<typeof EmbeddedSignupSchema>
}
